import DataHandlerHelper from "../../helpers/DataHandler.helper";
import InitClientUpdateLogic from "./ClientUpdate.logic";

const ClientUpdateComponent: React.FC = () => {
    const { selectedClient, clients, data, categories, prices, credentials, firstNameRef, lastNameRef, phoneRef, onSubmit, onDeleteClient, onChange, onChangeSearch, onPriceChange, onCredentialsChange, selectClient, removeSelectedClient } = InitClientUpdateLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Izmena klijenta</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={onSubmit}>Sačuvaj</button>

                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChangeSearch} name="client"></input>
                </div>
            </div>

            {selectedClient !== undefined && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <button className="btn-secondary" type="button" onClick={() => removeSelectedClient(selectedClient)}>{selectedClient.firstName} {selectedClient.lastName}</button>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                    <button type="button" key={c.id} onClick={() => selectClient(c)}>{c.firstName} {c.lastName}</button>
                ) : "")
                }
            </div>

            {selectedClient !== undefined && (
                <div style={{ marginTop: '16px' }}>
                    <div className="card">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div>
                                <label htmlFor="firstName">Ime</label>
                                <input placeholder="Unesi ime..." id="firstName" type={"text"} ref={firstNameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => lastNameRef.current.focus())} value={selectedClient.firstName} onChange={onChange} name="firstName" required></input>
                            </div>
                            <div>
                                <label htmlFor="lastName">Prezime</label>
                                <input placeholder="Unesi prezime..." id="lastName" type={"text"} ref={lastNameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => phoneRef.current.focus())} value={selectedClient.lastName} onChange={onChange} name="lastName" required></input>
                            </div>
                            <div>
                                <label htmlFor="phone">Broj telefona</label>
                                <input placeholder="Unesi broj telefona" id="phone" type={"text"} ref={phoneRef} value={selectedClient.phone} onChange={onChange} name="phone" required></input>
                            </div>
                            <div>
                                <label htmlFor="username">Korisničko ime</label>
                                <input placeholder="Korisničko ime" id="username" type={"text"} value={credentials.username} onChange={onCredentialsChange} name="username"></input>
                            </div>
                            <div>
                                <label htmlFor="password">Nova lozinka (ostavi prazno da se ne menja)</label>
                                <input placeholder="••••••••" id="password" type={"password"} value={credentials.password} onChange={onCredentialsChange} name="password" autoComplete="new-password"></input>
                            </div>
                        </div>
                    </div>

                    <h3 style={{ marginTop: '16px' }}>Cene po tipu treninga</h3>
                    {categories.map((cat) => (
                        <div className="card" key={cat.id} style={{ marginTop: '12px' }}>
                            <h4>{cat.name}</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {cat.trainingTypes?.map((tt: any) => (
                                    <div key={tt.id}>
                                        <label htmlFor={`price-${tt.id}`}>{tt.name}</label>
                                        <input
                                            id={`price-${tt.id}`}
                                            type="number"
                                            inputMode="numeric"
                                            min={0}
                                            step={1}
                                            placeholder="0"
                                            value={prices[tt.id] ?? ""}
                                            onChange={(e) => onPriceChange(tt.id, e.target.value)}
                                        ></input>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div style={{ marginTop: '16px' }}>
                <button className="btn-primary" type="button" onClick={onSubmit}>Sačuvaj</button>
            </div>

            {selectedClient !== undefined && (
                <div style={{ marginTop: '12px' }}>
                    <button className="btn-danger" type="button" onClick={onDeleteClient} style={{ width: '100%' }}>
                        Obriši klijenta
                    </button>
                </div>
            )}
        </div>
    );
}

export default ClientUpdateComponent;
